// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"c5b08f12","732":"4349c8a5","889":"a8f6b75b"}[chunkId] + ".chunk.js";
};